import { addToChainBefore } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/PlaceOrder";
import {
    ORDER_ALTERNATIVE_SHIPPING_BILL_TO_PROPERTY,
    ORDER_SELECTED_CARRIER_ACCOUNT_PROPERTY,
    ORDER_SELECTED_CARRIER_NAME_PROPERTY,
    ORDER_SHIPPING_INSTRUCTIONS_PROPERTY,
    ORDER_SHIPPING_TYPE_ID_PROPERTY,
} from "@thkStore/Common/Constants/ShippingConstants";
import { ApplicationShippingState } from "@thkStore/Store/Reducers/ShippingReducer";

type PlaceOrderHandlerType = Parameters<typeof PopulateApiParameter>[0];

/**
 * Send the additional values for ShippingCarrier
 */
export const SetShippingCartProperties = (props: PlaceOrderHandlerType) => {
    const { cartToUpdate } = props;
    if (!cartToUpdate) return;

    const shipping = (props.getState() as ApplicationShippingState).shipping;
    if (!shipping) return;

    if (!cartToUpdate.properties) {
        cartToUpdate.properties = {};
    }

    if (shipping.shippingTypeId) {
        cartToUpdate.properties[ORDER_SHIPPING_TYPE_ID_PROPERTY] = shipping.shippingTypeId;
    }
    if (shipping.selectedCarrierName) {
        cartToUpdate.properties[ORDER_SELECTED_CARRIER_NAME_PROPERTY] = shipping.selectedCarrierName;
    }
    cartToUpdate.properties[ORDER_SELECTED_CARRIER_ACCOUNT_PROPERTY] = shipping.accountNumber || "";
    cartToUpdate.properties[ORDER_SHIPPING_INSTRUCTIONS_PROPERTY] = shipping.shippingInstructions || "";

    if (shipping.selectedAlternativeAddressId) {
        cartToUpdate.properties[ORDER_ALTERNATIVE_SHIPPING_BILL_TO_PROPERTY] =
            shipping.selectedAlternativeAddressId;
    }
};

addToChainBefore(chain, PopulateApiParameter, SetShippingCartProperties);

if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(() => {
        chain.length = 0;
        originalChain.forEach(o => chain.push(o));
    });
}
